export enum CoreScoreNames {
  'Screentime' = 'screenTime',
  'Digital Intensity' = 'digitalIntensity',
  'Focus' = 'focus',
  'Digital Working hours' = 'workingHours',
  'Time in Calls' = 'timeInCalls',
  'Time in Meetings' = 'timeInMeetings',
}
